"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyJlFilled = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.MyJlFilled = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M16 28.5C22.9036 28.5 28.5 22.9036 28.5 16C28.5 9.09644 22.9036 3.5 16 3.5C9.09644 3.5 3.5 9.09644 3.5 16C3.5 22.9036 9.09644 28.5 16 28.5ZM8 19.7098V12.25H9.71728L12.058 15.1267L14.3988 12.25H16.1051V19.7098H14.2238V14.9408L12.1237 17.555H11.9487L9.8376 14.9408V19.7098H8ZM21.6805 19.7098H19.7991V16.1658L16.9005 12.25H18.9132L20.6961 14.6673L22.5009 12.25H24.5353L21.6805 16.133V19.7098Z", fillRule: "evenodd" })),
        size === 'medium' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM5.70508 14.9991V9.03125H7.0789L8.95151 11.3326L10.8241 9.03125H12.1892V14.9991H10.6841V11.1839L9.00401 13.2752H8.864L7.17516 11.1839V14.9991H5.70508ZM16.6495 14.9991H15.1444V12.1639L12.8255 9.03125H14.4356L15.8619 10.9651L17.3058 9.03125H18.9334L16.6495 12.1377V14.9991Z", fillRule: "evenodd" }))));
});
exports.MyJlFilled.displayName = 'MyJlFilled';
//# sourceMappingURL=MyJlFilled.js.map